import { theme } from 'modules/ui/theme';
import styled from 'styled-components';
import { Label, Subtitle } from 'modules/ui/typography';
import { mediaQuery } from 'modules/utils';

export const StyledInboxMessageDisplayContainer = styled.div`
  padding: 1.437rem;
  overflow-y: auto;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${theme.colors.primaryW};
  z-index: 9999;

  width: 100vw;
  min-height: 100vh;

  ${mediaQuery('md')} {
    position: initial;
    top: initial;
    bottom: initial;
    left: initial;
    right: initial;
    z-index: initial;

    padding: 2.625rem;

    width: initial;
    min-height: initial;
  }
`;

export const StyledInboxMessageDisplayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.625rem;
`;

export const StyledHeaderLogoContainer = styled.div`
  height: 2.625rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledHeaderLabelContainer = styled.div`
  display: none;

  ${mediaQuery('md')} {
    display: flex;
  }

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;

export const StyledCloseButtonContainer = styled.div`
  display: flex;

  ${mediaQuery('md')} {
    display: none;
  }

  align-items: center;
  justify-content: center;
  padding-bottom: 0.7rem;
`;

export const StyledInboxMessageDisplayLabel = styled(Label)`
  font-size: ${theme.fontSizes.body};
  color: ${theme.colors.primaryK4};
`;

export const StyledInboxMessageDisplayTitle = styled(Subtitle)`
  margin: 1.5rem 0 2.625rem 0;
  font-size: 1.5rem;
`;

export const StyledInboxMessageDisplayContent = styled.div`
  font-size: ${theme.fontSizes.body};
`;

export const StyledInboxMessageDisplayFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 1.5rem 0 2.625rem 0;
`;

export const StyledFooterLabelContainer = styled.div`
  display: flex;

  ${mediaQuery('md')} {
    display: none;
  }

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;
